var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{attrs:{"items":_vm.tableConfig.items.value,"fields":_vm.tableConfig.fields,"actions":_vm.tableConfig.actions,"loading":_vm.loading,"data-cy":"floors-table","search-data-cy":"floor-search"},on:{"clickItem":_vm.tableConfig.clickItemCallback},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('v-btn',{staticClass:"text-h4",attrs:{"color":"secondary","rounded":"","depressed":"","disabled":!_vm.$can('create', 'Floor'),"to":{ name: 'floor', params: { floorId: 'new' } },"data-cy":"create-floor"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus-circle-outline")]),_vm._v(" Create floor ")],1)]},proxy:true},{key:"value-createdAt",fn:function(ref){
var item = ref.item;
var value = ref.value;
var field = ref.field;
return [_vm._v(" "+_vm._s(_vm._f("moment")(value,"from"))+" ")]}},{key:"value-updatedAt",fn:function(ref){
var item = ref.item;
var value = ref.value;
var field = ref.field;
return [_vm._v(" "+_vm._s(_vm._f("moment")(value,"from"))+" ")]}},{key:"value-floors",fn:function(ref){
var item = ref.item;
var value = ref.value;
var field = ref.field;
return [_vm._v(" "+_vm._s(value ? value.length : 0)+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }